<div
  #containerRef
  class="mw-phone-input"
  [class.mw-phone-input--disabled]="disabled"
>
  <mat-select
    #countrySelectorRef
    class="mw-phone-input__country-selector"
    [class.mw-phone-input__country-selector--open]="countryPanelOpen"
    [disableOptionCentering]="true"
    (openedChange)="onDropdownPanelOpenChanged($event)"
    (blur)="onTouched()"
    (selectionChange)="onChanged()"
    panelClass="mw-phone-input-panel"
    [disabled]="disabled"
  >
    <mat-select-trigger>
      <mat-icon
        *ngIf="countrySelectorRef.value"
        svgIcon="mw-flags-set:{{ countrySelectorRef.value.countryCode }}"
      ></mat-icon>
    </mat-select-trigger>
    <mat-option *ngFor="let country of countries" [value]="country">
      <mat-icon svgIcon="mw-flags-set:{{ country.countryCode }}"></mat-icon>
      <span class="mw-country-name">
        {{
          'CORE.COMPONENT.PHONE_INPUT.COUNTRY_NAME.' + country.countryCode
            | translate
        }}
      </span>
      <span class="mw-phone-code">
        {{ country.phoneCode }}
      </span>
    </mat-option>
  </mat-select>
  <span *ngIf="countrySelectorRef.value" class="mw-phone-code">
    {{ countrySelectorRef.value.phoneCode }}
  </span>
  <input
    #numberInputRef
    matInput
    class="mw-phone-input__number-input"
    type="number"
    (input)="onChanged()"
    (focus)="onNumberInputFocusChanged(true)"
    (blur)="onNumberInputFocusChanged(false)"
    [disabled]="disabled"
    [placeholder]="placeholder"
  />
</div>
